import { openUploadModal } from '../../../State/uploadModal'

export default () => (dispatch) => {

  dispatch(openUploadModal())

}
